export const CONTROLLER_SHOW_TIMEOUT = 3 * 1000
